import { useContext } from "react";
import { CatalogEmptyStateContext } from "./CatalogEmptyStateContext";
export var useCatalogEmptyStateContext = function useCatalogEmptyStateContext() {
  var context = useContext(CatalogEmptyStateContext);
  if (!context) {
    throw new Error('useCatalogEmptyStateContext must be used within a CatalogEmptyStateContextProvider');
  }
  return context;
};